import script from "./CartProductInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./CartProductInfo.vue?vue&type=script&lang=ts&setup=true"

import "./CartProductInfo.vue?vue&type=style&index=0&id=22ce1a33&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22ce1a33"]])

export default __exports__